export default [{
    'text': 'Male',
    'value': 1
},
{
    'text': 'Female',
    'value': 2
}
]
;
